import styled from 'styled-components';

import { breakpoints, colors, fontFamily, zIndex } from '../../ui/variables';

const main = {
  height: {
    iphone: 48,
  },
};

export const headerVariables = {
  main,
};

export const HeaderStyle = styled.header`
  ${zIndex.space};
  background-color: ${colors.veryDarkGrayishBlue};
  box-sizing: border-box;
  display: flex;
  height: ${main.height.iphone}px;
  justify-content: space-between;
  left: 0;
  padding: 12px 20px;
  position: fixed;
  top: 0;
  width: 100vw;

  @media (min-width: ${breakpoints.ipadLandscape.width}px) {
    padding: 12px 68px;
  }

  .header-menu {
    display: block;
    width: fit-content;

    svg,
    .menu-logotypes {
      display: block;
      height: 24px;
      width: auto;
    }

    .show-menu-button {
      height: 20px;
      margin-top: 2px;
      width: 20px;

      svg {
        display: block;
        height: auto;
        width: 100%;
        fill: ${colors.mostlyWhite};
      }
    }
  }

  .header-actions {
    align-items: center;
    color: ${colors.white};
    display: flex;
    justify-content: flex-end;

    .avatar-wrapper {
      margin-right: 12px;
      width: 22px;

      svg {
        display: block;
        height: auto;
        width: 100%;
        fill: ${colors.mostlyWhite};
      }
    }

    .notification {
      margin-right: 22px;

      .notification-button-container {
        border-right: 2px solid ${colors.white};
        padding-right: 24px;
        .notification-button {
          position: relative;
          svg {
            height: 22px;
            width: 20px;
          }

          .unseen-notification {
            position: absolute;
            width: 12px;
            height: 12px;
            top: 10px;
            left: 15px;
            padding: 2px;
            font-size: 10px;
            border-radius: 50%;
            background-color: ${colors.softBlue};
          }
        }
      }
    }

    .action-login,
    .action-logout {
      ${fontFamily.sourceSansPro.regular}
      color: ${colors.mostlyWhite};
      font-size: 14px;
      letter-spacing: 0;
      line-height: 18px;
    }
  }

  .select-language-tool {
    color: ${colors.white};
    padding-top: 2px;

    .select-language-button {
      opacity: 0.3;
      transition: opacity 300ms;

      &:disabled {
        opacity: 1;
      }
    }
  }
    .icon {
      background-color: ${colors.veryDarkGrayishBlue};
      border-radius: 50%;
      display: inline-block;
      height: 16px;
      margin-left: 8px;
      width: 16px;

      svg {
        fill: ${colors.mostlyWhite};
      }
    }

  .user-menu{
    position: absolute;
    top: 48px;
    right: 20px;
    background-color: ${colors.veryDarkGrayishBlue};
    border-radius: 0px 0px 4px 4px;
    padding: 12px;
    z-index: ${zIndex.header + 1};
    height: fit-content;
    width: 200px;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);

    .action-profile,
    .action-password{
      ${fontFamily.sourceSansPro.regular}
      color: ${colors.mostlyWhite};
      font-size: 14px;
      letter-spacing: 0;
      line-height: 18px;
      background: none;
      border: none;
      cursor: pointer;
      margin-bottom: 12px;
      display: flex;
      align-items: center;
      width: 100%;
      padding: 8px 0;
      text-align: left;

      .icon-profile {
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 0 0 25px;
        margin-right: 8px;
        width: 25px;

        svg {
          fill: ${colors.mostlyWhite};
        }
      }

      .icon-password {
        display: inline-flex;
        flex: 0 0 25px;
        margin-right: 8px;
        height: 25px;
        width: 25px;

        svg {
          fill: ${colors.mostlyWhite};
        }
      }
    }

    .action-logout{
      ${fontFamily.sourceSansPro.regular}
      color: ${colors.mostlyWhite};
      font-size: 14px;
      letter-spacing: 0;
      line-height: 18px;
      background: none;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      width: 100%;
      padding: 8px 0;

      .icon-logout {
        display: inline-flex;
        flex: 0 0 20px;
        margin-right: 13px;
        height: 20px;
        width: 20px;

        svg {
          fill: ${colors.mostlyWhite};
        }
      }
    }
`;
